import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function DriveIcon({ size, className }: IconProps): ReactElement {
  return (
    <SvgIcon viewBox="0 0 32 32" fill="none" size={size} className={className}>
      {" "}
      <path
        d="M1.43279 20.333C1.42749 20.8031 1.54634 21.2742 1.78934 21.6955L5.04056 27.3321C5.51677 28.1577 6.39741 28.6663 7.3505 28.6663H24.6504C25.6035 28.6663 26.4841 28.1577 26.9603 27.3321L30.2115 21.6955C30.4545 21.2742 30.5734 20.8031 30.5681 20.333H1.43279Z"
        fill="#4285F4"
      />
      <path
        d="M25.994 28.3033L11.4102 3.04334C11.8164 2.80109 12.2867 2.66699 12.776 2.66699H19.2231C20.1758 2.66699 21.0561 3.17526 21.5325 4.00033L30.2101 19.0304C30.6863 19.8551 30.6865 20.8712 30.2107 21.6961L26.9594 27.3327C26.7235 27.7418 26.3882 28.0731 25.994 28.3033Z"
        fill="#FBBC04"
      />
      <path
        d="M20.5889 3.04335C20.1826 2.80109 19.7124 2.66699 19.223 2.66699H12.7759C11.8232 2.66699 10.9429 3.17526 10.4665 4.00033L1.78891 19.0304C1.31275 19.8551 1.31254 20.8712 1.78836 21.6961L5.03959 27.3327C5.27556 27.7418 5.61085 28.0731 6.00506 28.3033L20.5889 3.04335Z"
        fill="#34A853"
      />
      <path
        d="M30.5681 20.333C30.5734 20.8031 30.4545 21.2742 30.2115 21.6955L26.9603 27.3321C26.7243 27.7412 26.389 28.0725 25.9948 28.3026L21.3936 20.333H30.5681Z"
        fill="#EA4335"
      />
      <path
        d="M20.589 3.04335C20.1827 2.80109 19.7125 2.66699 19.2231 2.66699H12.776C12.2867 2.66699 11.8164 2.80109 11.4102 3.04334L15.9996 10.9924L20.589 3.04335Z"
        fill="#188038"
      />
      <path
        d="M1.43279 20.333C1.42749 20.8031 1.54634 21.2742 1.78934 21.6955L5.04056 27.3321C5.27654 27.7412 5.61183 28.0725 6.00603 28.3026L10.6073 20.333H1.43279Z"
        fill="#1967D2"
      />
    </SvgIcon>
  );
}
